<div class="reset-screen">

    <app-vormen></app-vormen>

    <div class="reset-card">

        <div class="brand-logo">
            <img src="assets/img/logo.svg" alt="OpStoom" class="logo-img" />
        </div>

        <h4 class="title">{{ "resetPassword.title" | translate }}</h4>
        <p class="subtitle">{{ "resetPassword.instruction" | translate }}</p>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <input
                    type="password"
                    formControlName="password"
                    autocomplete="new-password"
                    placeholder="{{ 'resetPassword.newPassword' | translate }}"
                    class="form-control" />
                <messages
                    class="field-error"
                    [form]="form"
                    [messagesObserver]="messages"
                    fieldname="password">
                </messages>
            </div>

            <div class="form-group">
                <input
                    type="password"
                    formControlName="confirmPassword"
                    autocomplete="new-password"
                    placeholder="{{ 'resetPassword.confirmPassword' | translate }}"
                    class="form-control" />
                <messages
                    class="field-error"
                    [form]="form"
                    [messagesObserver]="messages"
                    fieldname="confirmPassword">
                </messages>
            </div>

            <div class="button-container">
                <action-button
                    class="btn-save"
                    (actionEvent)="onSubmit($event)"
                    label="{{ 'resetPassword.save' | translate }}">
                </action-button>
            </div>
        </form>
    </div>
</div>
